import { PropsWithChildren } from 'react';

import { Card } from './styles';

const CardContainer = ({ children }: PropsWithChildren) => {
	return <Card>{children}</Card>;
};

export default CardContainer;
